import { EmptyState } from '@app/components/base/EmptyState';
import { defineMessage, FormattedMessage } from 'react-intl';
import { CreateVideoEditionEditButton } from './CreateVideoEditionEditButton';

const videoEditionsEmptyHelpMessage = defineMessage({
  id: 'videoEditions.emptyHelp',
  defaultMessage: 'Todavía no hay edits',
});

export interface VideoEditionsEditsEmptyStateProps {
  createWithAutoName: (currentEditCount: number) => void;
  isCreating: boolean;
}

/**
 * Centered empty state when there are no video edition edits for the parent source.
 */
export function VideoEditionsEditsEmptyState({
  createWithAutoName,
  isCreating,
}: VideoEditionsEditsEmptyStateProps) {
  return (
    <EmptyState
      centered
      help={<FormattedMessage {...videoEditionsEmptyHelpMessage} />}
      action={
        <CreateVideoEditionEditButton
          currentEditCount={0}
          createWithAutoName={createWithAutoName}
          isCreating={isCreating}
        />
      }
    />
  );
}
